import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-country-input',
  templateUrl: './country-input.component.html',
  styleUrls: ['./country-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CountryInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CountryInputComponent,
    },
  ],
})
export class CountryInputComponent {
  @Input()
  title = "Select Country...";

  @Input()
  isDisabled = false;


  @Input()
  countries = [
    "South Africa",
    "Lesotho",
    "Swaziland",
    "Angola",
    "Mozambique",
    "Zambia",
    "Malawi",
    "Zimbabwe",
    "DRC",
    "Tanzania",
    "Botswana",
    "Nambia",
  ];

  public value?: string;
  public localValue?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.value;
    }
  }

  onValueChange(val: string) {
    this.value = val;
    this.onChange(this.value);
    this.writeValue(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
